module.exports = __webpack_public_path__ + "img/need01.aa0b74f8.png";